export const showTimeZone = (tz: string) => tz.replace(/_/g, ' ');
